export const STORAGE_AUTH_TOKEN: string = 'Authorization';
export const STORAGE_HKEY: string = 'HashKey';
export const INSTRUCTIONS_FILE_NAME: string = 'craig-instructions.html';
export const STORAGE_QUOTA_EXCEEDED_NAME: string = 'QuotaExceededError';
export const FIREFOX_STORAGE_QUOTA_EXCEEDED_NAME: string = 'NS_ERROR_DOM_QUOTA_REACHED';
export const STORAGE_CHAT_MESSAGES_SUFFIX: string = 'chatMessages';
export const STORAGE_CHAT_HISTORY_SUFFIX: string = 'chatHistory';

export const RANDOM_RADIX: number = 36;
export const RANDOM_START_INDEX: number = 2;
export const RANDOM_LENGTH: number = 9;

export const BOM_DEV_ENV_URL: string = 'https://app.dev.parts.accuris.dev';
export const BOM_PROD_ENV_URL: string = 'https://4donline.ihs.com';
